export const insightNamespace = 'insight';
